<template>
  <header class="pa-4 bg-white border-primary5 flex items-center gap-2">
    <div class="flex justify-start items-center basis-0 flex-grow-1">
      <CButton v-tooltip="t('canvasUI.common.close')" class="w-11 h-11" size="large" type="primary" @click="closeApp()">
        <template #icon>
          <CIcon icon="close" size="16" />
        </template>
      </CButton>
    </div>

    <div
      v-tooltip="data.name"
      class="block overflow-hidden font-normal text-[20px] leading-8 tracking-wide text-ellipsis whitespace-nowrap"
    >
      {{ data.name }}
    </div>

    <div class="flex justify-end items-center basis-0 flex-grow-1 gap-2"></div>
  </header>
</template>

<script setup lang="ts">
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import { useAppStore } from '@collection-player/stores/app.store'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { data, closeApp } = useAppStore()
</script>
